import { ICreateFuncionarioAssinaturaUseCase } from "../../../presentation/useCases/create/create_funcionario_assinatura_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateFuncionarioAssinaturaUseCase
 */

export class CreateFuncionarioAssinaturaUseCase implements ICreateFuncionarioAssinaturaUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createFuncionarioAssinatura(
    idFuncionario: number,
    nroRegistro: string | null,
    ativo: number,
    file: File | null,
  ): Promise<void> {
    await this.repository.createFuncionarioAssinatura(
      ativo,
      idFuncionario,
      file,
      nroRegistro,
    );
  }
}